export const RESORT_SLUG_MAP: Record<string, number> = {
  salen: 1,
  are: 2,
  vemdalen: 3,
  hemsedal: 4,
  trysil: 5,
  hammarbybacken: 6,
}

export const RESORT_ID_MAP: Record<number, string> = Object.fromEntries(
  Object.entries(RESORT_SLUG_MAP).map(([slug, id]) => [id, slug])
)

export const DEFAULT_RESORT_SLUG = "salen"

export const getExternalIdFromSlug = (slug: string): number | undefined =>
  RESORT_SLUG_MAP[slug]

export const getSlugFromExternalId = (id: number): string | undefined =>
  RESORT_ID_MAP[id]
